import { CatalogCategory, CatalogTile } from "../config/tileCatalog";

// Canonical display order for the catalog categories. Shared by the left rail and the grouped
// "All templates" view so the section order never drifts from the rail order.
export const CATALOG_CATEGORY_ORDER: CatalogCategory[] = [
	CatalogCategory.UPLOAD,
	CatalogCategory.SCRAPING,
	CatalogCategory.SIGNALS,
	CatalogCategory.LINKEDIN,
	CatalogCategory.DATABASE,
	CatalogCategory.JOBS,
	CatalogCategory.FUNDING,
	CatalogCategory.REENGAGE,
	CatalogCategory.EMPTY,
];

export interface CatalogSection {
	category: CatalogCategory;
	tiles: CatalogTile[];
}

// Buckets each tile under a single section so the grouped view never shows the same tile twice.
// A tile can belong to several categories (used for rail filtering); for display we keep only its
// primary category (the first one), which is the most specific source for that tile.
export const groupCatalogTilesByPrimaryCategory = (tiles: CatalogTile[]): CatalogSection[] => {
	const tilesByCategory = new Map<CatalogCategory, CatalogTile[]>();

	tiles.forEach((tile) => {
		const primaryCategory = tile.categories[0];

		if (!primaryCategory) {
			return;
		}

		const bucket = tilesByCategory.get(primaryCategory) ?? [];

		bucket.push(tile);
		tilesByCategory.set(primaryCategory, bucket);
	});

	return CATALOG_CATEGORY_ORDER.map((category) => ({
		category,
		tiles: tilesByCategory.get(category) ?? [],
	})).filter((section) => section.tiles.length > 0);
};
